module.exports = __webpack_public_path__ + "img/page06_logo.25182dad.png";